export default __webpack_public_path__ + "static/media/gallery_13.15ac1ba3.jpg";